module.exports = __webpack_public_path__ + "static/media/kids_33.8556cad3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_33.jpg
// module id = 5889
// module chunks = 0